import {TOption} from './TOption'
export const configLetterModuleOptions: TOption[] = [
  {
    label: 'Sales Order',
    value: 'sales-order',
  },
  {
    label: 'Booking Code',
    value: 'booking-code',
  },
  {
    label: 'Contract',
    value: 'contract',
  },
  {
    label: 'Proforma Invoice',
    value: 'proforma-invoice',
  },
]
